import { Settings, WinLinesType } from "../../Settings";
import { WinLinesAnimationParams, GenericWinLinesAnimation } from "./GenericWinLinesAnimation";
import { IWinLinesFactory } from "./IWinLinesFactory";
import { WinLinesAnimation } from "./WinLinesAnimation";
import { WinNumberLinesAnimation } from "./WinNumberLinesAnimation";
import { WinSquares1MarkerAnimation } from "./WinSquares1MarkerAnimation";
import { WinSquareAnimations } from "./WinSquaresAnimations";
import { WinSquareMarkesAnimations } from "./WinSquaresMarkersAnimations";

export class SquareWinLinesFactory implements IWinLinesFactory
{
    public CreateWinLines(params: WinLinesAnimationParams):GenericWinLinesAnimation
    {
        if (Settings.winLinesType == WinLinesType.WinSquareMarkesAnimations) {
            return new WinSquareMarkesAnimations(params);
        }
        if (Settings.winLinesType == WinLinesType.WinSquareAnimations) {
            return new WinSquareAnimations(params);
        }
        if (Settings.winLinesType == WinLinesType.WinLinesAnimation) {
            return new WinLinesAnimation(params);
        }
        if (Settings.winLinesType == WinLinesType.WinNumberLinesAnimation) {
            return new WinNumberLinesAnimation(params);
        }
        if (Settings.winLinesType == WinLinesType.WinSquare1MarkeAnimations)
        {   return new WinSquares1MarkerAnimation(params);

        }
        return null
    }
}